
import Home from "./pages/Home";
import HomeIcon from '@mui/icons-material/Home';
import Listing from "./pages/Listing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Faqs from "./pages/Faqs";


export const publicRoutes = [
  { id: 100, path: "/", name: "Landing Page", Component: Home, icon: <HomeIcon /> },
  { id: 101, path: "/fairs", name: "Landing Page", Component: Listing, icon: <HomeIcon /> },
  { id: 102, path: "/about", name: "About", Component: About, icon: <HomeIcon /> },
  { id: 103, path: "/contact", name: "Contact", Component: Contact, icon: <HomeIcon /> },
  { id: 104, path: "/faq", name: "Faqs", Component: Faqs, icon: <HomeIcon /> }
];

export const privateRoutes = [
  { id: 202, path: "/update-profile", name: "Profile", Component: Home }
];

export const filteredRoute = (user) => {
  const x = privateRoutes.filter(menu => {
    if (menu.path === "/" && user?.roles?.includes("user")) return true;
  })
  return x
};


export const clientMenus = () => {
  const filteredRoutes = publicRoutes.filter(pr => pr.clientMenu)
  return filteredRoutes
}